import { CompanyDocument, PersonalDocument } from '@scansource-brazil/zeus-core-ui/utils';
import { adaptCustomerDocument, dateStringToModel, formatCurrency } from './helpers';

export class SalesCommissionListItem {
  salesCommissionId: string = '';
  finalCustomerDocument: CompanyDocument | PersonalDocument | string = '';
  finalCustomerName: string = '';
  invoiceNumber: string = '';
  invoiceSerieNumber: string = '';
  salesOrderNumber: string = '';
  billingDate: string = '';
  netValue: string = '-';
  createdAt: string = '';

  constructor(data?: SalesCommissionListItem) {
    Object.assign(this, data);
  }

  fromDto(dto: Partial<SalesCommissionListItemDto>): SalesCommissionListItem {
    this.salesCommissionId = dto.invoiceLegacyId ? dto.invoiceLegacyId.toString() : '';
    this.finalCustomerDocument = adaptCustomerDocument(dto.finalCustomerDocument ?? null);
    this.finalCustomerName = dto.finalCustomerName ?? '';
    this.invoiceNumber = dto.invoiceNumber ?? '';
    this.invoiceSerieNumber = dto.invoiceSerieNumber ?? '';
    this.salesOrderNumber = dto.salesOrderNumber?.toString() ?? '';
    this.billingDate = dateStringToModel(dto.billingDate);
    this.netValue = formatCurrency(dto.netValue);
    this.createdAt = dateStringToModel(dto.createdAt);
    return this;
  }

  static adapter(dto: Partial<SalesCommissionListItemDto>): SalesCommissionListItem {
    return new SalesCommissionListItem().fromDto(dto);
  }
}

export type SalesCommissionListItemDto = {
  invoiceLegacyId: null | string;
  billingDate: null | string;
  finalCustomerDocument: null | string;
  finalCustomerName: null | string;
  invoiceNumber: null | string;
  invoiceSerieNumber: null | string;
  salesOrderNumber: null | number;
  netValue: null | number;
  createdAt: null | string;
};
